import { render } from "./Palette.vue?vue&type=template&id=a55112d6&scoped=true"
import script from "./Palette.vue?vue&type=script&lang=js"
export * from "./Palette.vue?vue&type=script&lang=js"

import "./Palette.vue?vue&type=style&index=0&id=a55112d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a55112d6"]])

export default __exports__